import React from 'react'
import { Button, Typography } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { Dimension } from '../../../../../features/dimension/types/Dimension'

const { Text } = Typography

interface DimensionInspectorChildrenProps {
  childDimensions: Dimension[]
  canEdit: boolean
  onAddChild: () => void
}

const DimensionInspectorChildren: React.FC<DimensionInspectorChildrenProps> = ({
  childDimensions,
  canEdit,
  onAddChild
}) => {
  const { t } = useTranslation()

  return (
    <div style={{ marginTop: 16 }}>
      <Text strong>{t('dimensionsPage:inspectorChildren', { count: childDimensions.length })}</Text>
      {canEdit && (
        <div style={{ marginTop: 8 }}>
          <Button icon={<PlusOutlined />} onClick={onAddChild}>
            {t('dimensionsPage:actionAddChild')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default DimensionInspectorChildren
